import Search from "../Search/SearchForm";
import { NavStyled } from "./NavStyled/NavStyled";
function Nav() {
  return (
    <NavStyled>
      <h1>Gamer</h1>
      <Search />
    </NavStyled>
  );
}

export default Nav;
